import VueCookie from 'vue-cookie';

export const ACCESS_TOKEN = VueCookie.get('access_token');
export const CSRF_TOKEN = '';
export const XSRF_TOKEN = '';



const API_URL = (process.env.NODE_ENV === 'development' ? "https://staging.api.generations.codespace.co.za/api/v3/" : "https://api.genexinstitute.com/api/v3/");
export const API_V4_URL = (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging' ? "https://staging.api.generations.codespace.co.za/api/v4/" : "https://api.genexinstitute.com/api/v4/");
const CANVAS_URL = (process.env.NODE_ENV === 'development' ? "https://staging.api.generations.codespace.co.za/api/v4/" : "https://api.genexinstitute.com/api/v4/");
const DEFAULT_BASE_URL = (process.env.NODE_ENV === 'development' ? "https://staging.genexinstitute.codespace.co.za/" : "https://api.genexinstitute.com/'");
const SOCKET_AUTH_URL = (process.env.NODE_ENV === 'development' ? "https://staging.api.generations.codespace.co.za/api/broadcasting/auth" : "https://api.genexinstitute.com/api/broadcasting/auth");
const SOCKET_KEY = (process.env.NODE_ENV === 'development' ? 339 : 227);

export const WEBSOCKET_HOST = (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development' ? "staging.api.generations.codespace.co.za/socket" : "api.genexinstitute.com/socket");
export const WEBSOCKET_PORT = (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development' ? 9000 : 9000);

export {
  SOCKET_KEY
}
export {
  CANVAS_URL
}
export {
  SOCKET_AUTH_URL
}

export {
  API_URL
}
export {
  DEFAULT_BASE_URL
}
// export const DEFAULT_BASE_URL = 'http://gen-lms.site/';
// export const API_URL = 'http://gen-lms.site/api/v3/';
export const ROUTES_ACCESSIBLE_IF_NOT_LOGGED_IN = [
  'auth.login',
  'auth.register',
];
export const ROUTES_ACCESSIBLE_AFTER_LOGGED_IN = [
  'courses',
  'dashboard',
  'contact',
  'e-studio',
  'faq',
  'courses.entry',
  'projects',
  'calendar',
];